@if (show) {
  <div class="top-header">
    <div class="sw-link-container top-header-nav my-schedule-link"></div>
    <div class="right-top-header">
      @if (userName || lastUpdatedDate) {
        <div class="last-updated">
          <span>{{ page }} last updated by:</span>
          {{ userName }}
          {{ lastUpdatedDate | date: 'HH:mm MM/dd/yyyy' }}
        </div>
      }
    </div>
  </div>
}
